"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
function CarsBarSort(props) {
    var current = props.current, setSort = props.setSort, _a = props.disabled, disabled = _a === void 0 ? false : _a, options = props.options;
    function sortHandler(id) {
        var direction = id === current ? "-" + id : id;
        setSort(direction);
    }
    function checkCurrentDirection(currentId, id) {
        var cleanId = currentId.replace(/^-/, '');
        return cleanId === id;
    }
    function checkDescDirection(direction) {
        return /^-/.test(direction);
    }
    return (react_1.default.createElement("div", { className: "azgazui__cars-sort" },
        react_1.default.createElement("span", { className: "azgazui__cars-sort-label" }, "\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E:"),
        options.map(function (_a) {
            var id = _a.id, label = _a.label;
            var currentDirection = checkCurrentDirection(current, id);
            var descDirection = checkDescDirection(current);
            var currentDescDirection = currentDirection && descDirection;
            return (react_1.default.createElement("button", { type: "button", className: classnames_1.default('azgazui__cars-sort-button', { 'azgazui__cars-sort-button_active': currentDirection }, { 'azgazui__cars-sort-button_up': currentDescDirection }), key: id, onClick: function () { return sortHandler(id); }, disabled: disabled }, label));
        })));
}
exports.default = CarsBarSort;
CarsBarSort.displayName = 'CarsBarSort';
CarsBarSort.propTypes = {
    current: prop_types_1.default.string.isRequired,
    setSort: prop_types_1.default.func.isRequired,
    // eslint-disable-next-line react/require-default-props
    disabled: prop_types_1.default.bool,
    options: prop_types_1.default.arrayOf(prop_types_1.default.any).isRequired,
};
